<template>
  <div id="yazdirilacak-alan" class="form-container">
<div style="float: inline-end;margin: 3px;"> <v-btn color="success" @click="bicimliKopyala">Kopyala</v-btn></div>
    <div  style="padding: 5px;">    
       
        <table>
            <tr>
                <td style="text-align: center;"><img width="64" height="64" src="../assets/amasya_logo.png" /></td>
                <td style="text-align: center; font-family: 'Times New Roman', Times, serif;
  font-size: 14pt;
  font-weight: bold;"> 	AMASYA ÜNİVERSİTESİ<br>
SAĞLIK BİLİMLERİ FAKÜLTESİ <br>
EBELİK BÖLÜMÜ<br>
MEZUNİYET KRİTERLERİ ONAY FORMU</td>
            </tr>
        </table>
        <br>


    <table class="bilgi-tablosu">
      <tbody>
                <tr>
          <th style="text-align: left;" >ÖĞRENCİ ID</th>
          <td>{{ studentInfo.kullaniciId }}</td>
        </tr>
        <tr>
          <th style="text-align: left;" >ÖĞRENCİ ADI SOYADI</th>
          <td>{{ studentInfo.name }}</td>
        </tr>
        <tr>
          <th style="text-align: left;">ÖĞRENCİ NUMARASI</th>
          <td>{{ studentInfo.number }}</td>
        </tr>
        <tr>
          <th style="text-align: left;">DANIŞMAN BİLGİLERİ</th>
          <td>{{ studentInfo.advisor }}</td>
        </tr>
      </tbody>
    </table>
    <br>

    <table style="text-align: center;" class="kriter-tablosu">
      <thead>
        <tr>
          <th>KRİTERLER</th>
          <th>ONAYLANAN KRİTER SAYISI</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(kriter, index) in criteria" :key="index">
          <td>{{ kriter.label }}</td>
          <td class="center-text">{{ kriter.count }}</td>
        </tr>
      </tbody>
    </table>

    <p class="onay-metni" style="text-align: center;">
      Yukarıda bilgileri yer alan öğrencinin, Ebelik Lisans Programını başarıyla
      tamamlayabilmesi için belirlenen asgari mezuniyet kriterlerini sağladığı,
      ilgili komisyon tarafından yapılan inceleme ve değerlendirme sonucunda tespit
      edilmiştir.
    </p>


    <table class="kriter-tablosu">
        <tr>
            <td>Komisyon Başkanı</td>
            <td>Komisyon Üyesi</td>
            <td>Komisyon Başkanı</td>
        </tr>
        <tr>
            <td>Tarih: .../.../.....</td>
            <td>Tarih: .../.../.....</td>
            <td>Tarih: .../.../.....</td>
        </tr>
        <tr>
            <td><br></td>
            <td><br></td>
            <td><br></td>
            
            
        </tr>
    </table>
    <br>
    <p style="text-align: center;font-weight:bold;">
Bölüm Başkanı
    </p>
<br>
<p style="text-align: center;" >Bu form www.form.amasya.edu.tr  sistemi ile entegredir.Form çıktısı {{ formInfo.id }} id ve  {{ formInfo.date }} tarihli  zaman damgası ile kayıt altına alınmıştır. </p>
</div>

  </div>
</template>

<script>
export default {
  name: 'GraduationCriteriaForm',
  props: {
    title: {
      type: String,
      default: 'Ebelik Lisans Programı Mezuniyet Kriterleri Değerlendirme Formu'
    },
    studentInfo: {
      type: Object,
      default: () => ({
        kullaniciId:'',
        name: '',
        number: '',
        advisor: ''
       
      })
    },
        formInfo: {
      type: Object,
      default: () => ({
        id: '',
        date: '',
     
      })
    },
    criteria: {
      type: Array,
      default: () => [
        { label: 'SAĞLIKLI GEBE İZLEMİ', count: '' },
        { label: 'RİSKLİ GEBE İZLEMİ', count: '' },
        { label: 'İNNATAL İZLEMİ', count: '' },
        { label: 'LOHUSA İZLEMİ', count: '' },
        { label: 'YENİDOĞAN İZLEMİ', count: '' }
      ]
    },
    committee: {
      type: Array,
      default: () => [
        { role: 'Komisyon Başkanı', name: '', date: '' },
        { role: 'Komisyon Üyesi', name: '', date: '' },
        { role: 'Komisyon Üyesi', name: '', date: '' }
      ]
    },
    departmentHead: {
      type: Object,
      default: () => ({
        role: 'Bölüm Başkanı',
        name: '',
        date: ''
      })
    }
  },
  methods:{
     bicimliKopyala() {
  const alan = document.getElementById("yazdirilacak-alan");

  // 1. Tarayıcıda görünmez bir seçim (Selection) alanı oluşturun
  const range = document.createRange();
  range.selectNodeContents(alan); 
  
  const selection = window.getSelection();
  selection.removeAllRanges(); // Mevcut diğer seçimleri temizler
  selection.addRange(range);    // Hedef alanı seçilmiş gibi yapar

  try {
    // 2. Seçili alanı biçimlendirmesiyle (HTML) panoya kopyalar
    document.execCommand("copy");
    alert("Biçimlendirilmiş metin kopyalandı! Word'e yapıştırabilirsiniz.");
  } catch (err) {
    alert("Kopyalama başarısız oldu.");
  }

  // 3. Kullanıcı ekranında seçili kalmasın diye seçimi kaldırın
  selection.removeAllRanges();
},
    alaniKopyala() {
  // 1. Kopyalanacak alanı seçin
  const element = document.getElementById("yazdirilacak-alan");
  
  // 2. Alanın içindeki metni alın
  const metin = element.innerText;

  // 3. Metni panoya kopyalayın
  navigator.clipboard.writeText(metin)
    .then(() => {
      alert("Metin başarıyla kopyalandı!");
    })
    .catch(err => {
      console.error("Kopyalama başarısız: ", err);
    });
}
  }
}
</script>

<style scoped>
.form-container {
  /*max-width: 700px;*/
  margin: 20px auto;
  background: #ffffff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  line-height: 1.6;
   width: 210mm;
    height: 297mm;
    padding: 20mm; /* Sayfa içi güvenli içerik alanı */
    box-sizing: border-box;
    page-break-after: always;
}

h2 {
  text-align: center;
  color: #2c3e50;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 1.3rem;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #34495e;
  padding-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 30px;
}

th, td {
  border: 1px solid black;
  padding: 10px 13px;
  text-align: left;
  font-size: 0.95rem;
}

.bilgi-tablosu th {
  background-color: #f8f9fa;
  color: #2c3e50;
  font-weight: 600;
  width: 35%;
}

.kriter-tablosu th {
  text-align: center;
  background-color: #34495e;
  color: #fff;
}

.kriter-tablosu th:first-child {
  width: 65%;
}

.center-text {
  text-align: center;
}

.onay-metni {
  text-align: justify;
  margin: 30px 0;
  font-size: 1rem;
  text-indent: 30px;
  color: #2c3e50;
}

/* İmza Alanları Düzeni */
.komisyon-konteyner {
  display: table;
  width: 100%;
  margin-top: 40px;
  border-spacing: 15px 0;
}

.komisyon-kart {
  display: table-cell;
  text-align: center;
  border: 1px dashed #bdc3c7;
  padding: 15px;
  border-radius: 6px;
  background-color: #fdfdfd;
  width: 33.33%;
}

.unvan {
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}

.tarih {
  font-size: 0.85rem;
  color: #7f8c8d;
  margin-bottom: 45px;
}

.isim-yeri {
  border-top: 1px solid #eee;
  padding-top: 5px;
  font-size: 0.9rem;
  color: #95a5a6;
}

.bolum-baskani-konteyner {
  margin-top: 40px;
  text-align: center;
}

.baskan-kart {
  display: inline-block;
  width: 250px;
}

@media print {
  body {
    background: #fff;
  }
  .form-container {
    box-shadow: none;
    padding: 0;
    max-width: 100%;
  }
  .komisyon-kart {
    border: 1px solid #bdc3c7;
  }
  p{
    text-align: center;
  }
}
</style>